
import { AdminTemplate, MerchantValueDatedTransactionDetailsComponent } from "../../components";

export const MerchantValueDatedTransactionDetails = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Üye İşyeri Valör Tarihi İşlem Detayları",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={true}>
            <MerchantValueDatedTransactionDetailsComponent />
        </AdminTemplate>
    );
};

